import { render, staticRenderFns } from "./IngredientsDetail.vue?vue&type=template&id=d2b7dab8&scoped=true"
import script from "./IngredientsDetail.vue?vue&type=script&lang=js"
export * from "./IngredientsDetail.vue?vue&type=script&lang=js"
import style0 from "./IngredientsDetail.vue?vue&type=style&index=0&id=d2b7dab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b7dab8",
  null
  
)

export default component.exports